import { render, staticRenderFns } from "./index.vue?vue&type=template&id=67eb9d02"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=67eb9d02&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/luxury_dreams_production/releases/20261103171319/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67eb9d02')) {
      api.createRecord('67eb9d02', component.options)
    } else {
      api.reload('67eb9d02', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=67eb9d02", function () {
      api.rerender('67eb9d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/navi/index.vue"
export default component.exports